module.exports = wp.apiFetch;